import { useState } from "react";
import { AdmAuth, Yn } from "@/constants/code";
import { AdmListRequestDto } from "@/dto/AdmDto";

export default function useFilter(
  values: AdmListRequestDto,
  onChange: (values: AdmListRequestDto) => void,
  onReset: () => void
) {
  const [formValues, setFormValues] = useState<AdmListRequestDto>(values);

  const handleUseYnChange = (value: Yn[]) => {
    setFormValues((prev) => ({
      ...prev,
      useYn: value,
    }));
  };

  const handleAdmAuthChange = (value: AdmAuth[]) => {
    setFormValues((prev) => ({
      ...prev,
      admAuth: value,
    }));
  };

  const handleKeywordChange = (value: string) => {
    setFormValues((prev) => ({
      ...prev,
      keyword: value,
    }));
  };

  const handleSearch = () => {
    onChange(formValues);
  };

  const handleReset = () => {
    setFormValues(values);
    onReset();
  };

  return {
    formValues,
    handleSearch,
    handleReset,
    handleUseYnChange,
    handleAdmAuthChange,
    handleKeywordChange,
  };
}
